<template>
<div class="container-fluid">
    <div class="row">

        <div class="col-xs-12">
          <label>Anchor</label>
          #<input class="form-control inlined" v-model="anchor" v-on:change="notifyChanges" />
        </div>

        <div class="col-xs-12">
          <input type="text" v-model="openerText" /> Tekst open-knop
        </div>

        <div class="col-xs-12">
          Status <select v-model="openerStatus">
            <option value="hidden">verborgen</option>
            <option value="tab">alleen tab weergeven</option>
            </select>
        </div>

        <div class="col-xs-12">
            <p>
                Salesfeed triggercode om de tab weer te geven: displayBlockPopupImageLeftTextRightTab({{ JSON.stringify(anchor) }});<br />
                Salesfeed triggercode om de popup te openen: displayBlockPopupImageLeftTextRightPopup({{ JSON.stringify(anchor) }});
            </p>
        </div>

        <div class="col-xs-6">
        <ImageUploadComponent label="Afbeelding links" v-model="mainImage" containerStyle="float:left;border:1px solid green;" />
        </div>

        <div class="col-xs-6">
            <div class="row">
                <div class="col-xs-12">
                    <KendoValueComponent v-model="tekstGroot" :tools="tools"/>
                </div>
                <div class="col-xs-12">
                    <KendoValueComponent v-model="tekstKlein" :tools="tools"/>
                </div>
                <div class="col-xs-12">
                    <ButtonComponent v-model="mainButton" />
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script type="application/javascript">
    export default {
        mounted()
        {
            for(let k of this.dataKeys)
                this.$watch(k, this.notifyChanges, { immediate: true });
        },
        methods: {
            notifyChanges()
            {
                let obj = {};
                for(let k of this.dataKeys)
                    Vue.set(obj, k, this[k]);
                this.$emit('change', obj);
            }
        },
        data()
        {
            let obj = {
                tools: ["cut", "copy", "paste", "bold", "italic", "superscript", "underline", "insertUnorderedList", "insertOrderedList", "createLink", "unlink", "cleanFormatting"],
                dataKeys: Object.keys(this.data),
            };
            for(let k of obj.dataKeys)
                Vue.set(obj, k, this.data[k]);
            return obj;
        },
        props: ['data']
    }
</script>
